import { ContentTypeCode, RoomContentType } from '@/services/cms'
import { ViverseWorldCardType } from '@/types/viverse-world-card'

export type NonBannerCardType = Exclude<ViverseWorldCardType, 'banner'>

const CONTENT_TYPE_TO_CARD_TYPE: Record<ContentTypeCode, NonBannerCardType> = {
  experiences: 'experiences',
  games: 'games',
  videos: 'videos',
  templates: 'experiences',
} as const

export function getCardType(
  contentType: Pick<RoomContentType, 'code'> | null | undefined,
): NonBannerCardType {
  return contentType?.code ? CONTENT_TYPE_TO_CARD_TYPE[contentType.code] : 'experiences'
}

const SEVEN_DAYS_MS = 7 * 24 * 60 * 60 * 1000

const isWithinSevenDays = (dateStr: string | undefined): boolean => {
  if (!dateStr) return false
  return Date.now() - new Date(dateStr).getTime() <= SEVEN_DAYS_MS
}

export const isNewRoom = (firstPublicDate: string | undefined): boolean =>
  isWithinSevenDays(firstPublicDate)

export const isUpdatedRoom = (
  lastUpdatedAt: string | undefined,
  firstPublicDate: string | undefined,
): boolean => isWithinSevenDays(lastUpdatedAt) && !isNewRoom(firstPublicDate)
